window.GT_R=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
window.GT_T=function(k){var m=window.GT_I18N||{};return m[k]!=null?m[k]:k;};
var GT_R=window.GT_R,T=window.GT_T;
window.gtQbClose||(window.gtQbClose=1,document.addEventListener('click',function(e){var x=e.target.closest('[data-qb-close]');if(x){e.preventDefault();e.stopPropagation();var p=x.closest('.gt-product');if(p)p.classList.remove('is-qb-open');}},true));
window.gtQbSel||(window.gtQbSel=1,(function(){
  function card(el){return el.closest('[data-card]')||el.closest('.gt-product');}
  document.addEventListener('click',function(e){
    var sw=e.target.closest('[data-card-swatch]');if(sw){var cs=card(sw);if(cs){delete cs.dataset.selVid;cs.querySelectorAll('.gt-qb__btn.is-sel').forEach(function(x){x.classList.remove('is-sel');});var z=cs.querySelector('.gt-cardbtn__size');if(z)z.textContent='';}}
    var sb=e.target.closest('.gt-qb__btn');
    if(sb&&!sb.disabled){e.preventDefault();e.stopPropagation();var c=card(sb);if(!c)return;
      c.querySelectorAll('.gt-qb__btn.is-sel').forEach(function(x){x.classList.remove('is-sel');});sb.classList.add('is-sel');
      var inp=sb.closest('form')&&sb.closest('form').querySelector('[data-qb-id]');c.dataset.selVid=inp?inp.value:'';c.dataset.selSize=sb.textContent.trim();c.classList.remove('is-hint');
      var b=c.querySelector('[data-card-cart]');if(b){var s=b.querySelector('.gt-cardbtn__size');if(!s){s=document.createElement('span');s.className='gt-cardbtn__size';b.appendChild(s);}s.textContent=' · '+c.dataset.selSize;}
      return;}
    var cb=e.target.closest('[data-card-cart]');
    if(cb){var c2=card(cb);if(!c2)return;
      if(c2.dataset.selVid){e.preventDefault();e.stopImmediatePropagation();
        var f=document.createElement('form');f.setAttribute('action',''+GT_R+'cart/add');f.setAttribute('method','post');f.setAttribute('data-gt-add','');f.style.display='none';
        var i=document.createElement('input');i.type='hidden';i.name='id';i.value=c2.dataset.selVid;f.appendChild(i);
        var q=document.createElement('input');q.type='hidden';q.name='quantity';q.value='1';f.appendChild(q);
        c2.appendChild(f);f.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));setTimeout(function(){f.remove();},2000);
        c2.classList.remove('is-qb-open');
        var o=cb.innerHTML;cb.classList.add('is-added');
      } else if(c2.classList.contains('is-qb-open')){e.preventDefault();e.stopImmediatePropagation();c2.classList.add('is-hint');}
    }
  },true);
  document.addEventListener('mouseleave',function(){},true);
  document.addEventListener('submit',function(e){var f=e.target;if(f.closest&&f.closest('.gt-qb')){e.preventDefault();e.stopImmediatePropagation();}},true);
})());
/* Giotelli theme — lightweight vanilla interactions.
   Cart uses Shopify AJAX API where available; falls back gracefully. */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (cents) => { const v = cents / 100; return (cents % 100 === 0 ? v.toLocaleString('de-DE', { maximumFractionDigits: 0 }) : v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + '€'; };

  /* ---------- Drawer + overlay ---------- */
  function openDrawer() { $('.gt-drawer')?.classList.add('is-open'); $('.gt-overlay')?.classList.add('is-open'); }
  function closeDrawer() { $('.gt-drawer')?.classList.remove('is-open'); $('.gt-overlay')?.classList.remove('is-open'); }
  function openMobileNav() { $('.gt-mobile-nav')?.classList.add('is-open'); $('.gt-overlay')?.classList.add('is-open'); }
  function closeAll() { closeDrawer(); $('.gt-mobile-nav')?.classList.remove('is-open'); $('[data-filters]')?.classList.remove('is-open'); }

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-gt]');
    if (t) {
      const a = t.getAttribute('data-gt');
      if (a === 'open-cart') { e.preventDefault(); var mn = $('.gt-mobile-nav'); if (mn) mn.classList.remove('is-open'); openDrawer(); refreshCart(); }
      if (a === 'close-cart') { e.preventDefault(); closeDrawer(); }
      if (a === 'open-nav') { e.preventDefault(); openMobileNav(); }
      if (a === 'open-filters') { e.preventDefault(); $('[data-filters]')?.classList.add('is-open'); $('.gt-overlay')?.classList.add('is-open'); }
      if (a === 'close-filters') { e.preventDefault(); $('[data-filters]')?.classList.remove('is-open'); $('.gt-overlay')?.classList.remove('is-open'); }
      if (a === 'close-overlay') { closeAll(); }
    }
    if (e.target.classList.contains('gt-overlay')) closeAll();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* ---------- AJAX cart ---------- */
  async function refreshCart() {
    try {
      const r = await fetch(GT_R+'cart.js'); const cart = await r.json();
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.style.display = cart.item_count ? '' : 'none'; });
      try {
        const h = await fetch(GT_R+'cart?view=drawer', { credentials: 'same-origin' });
        if (h.ok) {
          const tmp = document.createElement('div'); tmp.innerHTML = await h.text();
          const nd = tmp.querySelector('.gt-drawer'), od = $('.gt-drawer');
          if (nd && od) { if (od.classList.contains('is-open')) nd.classList.add('is-open'); od.replaceWith(nd); if (window.gtCdUpsell) { try { window.gtCdUpsell(); } catch (e3) {} } return cart; }
        }
      } catch (e2) {}
      renderDrawer(cart); return cart;
    } catch (e) { return null; }
  }
  function renderDrawer(cart) {
    const list = $('.gt-drawer__items'); if (!list) return;
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.style.display = cart.item_count ? '' : 'none'; });
    const sub = $('[data-cart-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
    if (!cart.items.length) { list.innerHTML = '<p style="font-size:14px;color:var(--ink-500);padding:40px 0">'+T('cart_empty_dot')+'</p>'; return; }
    list.innerHTML = cart.items.map((it) => `
      <div class="gt-dline">
        <div class="gt-dline__media"><div class="gt-photo gt-photo--ratio">${it.image ? `<img src="${it.image}" alt="">` : ''}</div></div>
        <div style="flex:1">
          <div style="font-size:15px">${it.product_title}</div>
          <div style="font-size:12px;color:var(--ink-500);margin-top:4px">${(it.options_with_values || []).map((o) => o.value).join(' · ')} · ${T('qty')} ${it.quantity}</div>
          <div style="font-size:14px;margin-top:8px">${money(it.final_line_price)}</div>
        </div>
      </div>`).join('');
  }

  async function addToCart(form) {
    const data = new FormData(form);
    try {
      const r = await fetch(GT_R+'cart/add.js', { method: 'POST', body: data });
      if (!r.ok) throw new Error('add failed');
      await refreshCart(); openDrawer();
    } catch (e) { form.submit(); }
  }

  /* ---------- Cart drawer: quantity +/- and remove via AJAX ---------- */
  async function changeLine(line, qty) {
    try {
      const r = await fetch((typeof GT_R === 'string' ? GT_R : '/') + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) });
      if (!r.ok) { let msg = ''; try { const j = await r.json(); msg = j.description || j.message || ''; } catch (e0) {} return { ok: false, msg: msg }; }
      await refreshCart();
      return { ok: true };
    } catch (e) { return { ok: false, msg: '' }; }
  }
  function cdNote(box, msg) {
    if (!box) return; const line = box.closest('.gt-cd__line') || box.parentNode;
    let n = line.querySelector('.gt-cd__note'); if (!n) { n = document.createElement('div'); n.className = 'gt-cd__note'; box.parentNode.insertBefore(n, box.nextSibling); }
    n.textContent = msg || (typeof T === 'function' && T('stock_limit')) || 'Nur die verfügbare Menge kann bestellt werden.'; setTimeout(() => { n.remove(); }, 3500);
  }
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-cd-qty]');
    if (q) {
      e.preventDefault();
      if (q.classList.contains('is-busy')) return;
      const m = (q.getAttribute('href') || '').match(/line=(\d+)/);
      const line = +(q.getAttribute('data-line') || (m ? m[1] : 0)); const qty = +q.getAttribute('data-cd-qty');
      if (!line || qty < 0) return;
      if (q.classList.contains('is-max')) { cdNote(q.closest('.gt-stepper--sm')); return; }
      const box = q.closest('.gt-stepper--sm'); if (box) box.classList.add('is-busy');
      changeLine(line, qty).then((res) => { if (box) box.classList.remove('is-busy'); if (!res.ok) cdNote(box, res.msg); });
      return;
    }
    const rm = e.target.closest('.gt-cd__rm, [data-cd-remove]');
    if (rm && rm.closest('.gt-drawer')) {
      const m = (rm.getAttribute('href') || '').match(/line=(\d+)/); const ln = +(rm.getAttribute('data-line') || (m ? m[1] : 0));
      if (ln) { e.preventDefault(); changeLine(ln, 0).then((res) => { if (!res.ok) window.location.href = rm.getAttribute('href'); }); }
    }
  });

  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-gt-add]');
    if (f) { e.preventDefault(); addToCart(f); }
  });

  /* ---------- PDP: accordions ---------- */
  $$('.gt-acc__head').forEach((h) => h.addEventListener('click', () => h.parentElement.classList.toggle('is-open')));

  /* ---------- PDP: variant matcher (colour + size combinations) ---------- */
  $$('[data-product-form]').forEach((root) => {
    let variants = [];
    try { variants = JSON.parse($('[data-variants]', root).textContent); } catch (e) { return; }
    const select = $('[data-variant-select]', root);
    const pickers = $$('[data-option-index]', root);
    const priceNow = $('[data-price]', root);
    const priceWas = $('[data-compare]', root);
    const priceBlock = $('[data-price-block]', root);
    const addBtn = $('[data-add-btn]', root);
    const addLabel = $('[data-add-label]', root);

    const money = (cents) => { const v = cents / 100; return (cents % 100 === 0 ? v.toLocaleString('de-DE', { maximumFractionDigits: 0 }) : v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + '€'; };
    const norm = (s) => String(s == null ? '' : s).trim().toLowerCase();
    const selected = [];
    const cur0 = select && variants.find((v) => String(v.id) === String(select.value));
    pickers.forEach((p) => {
      const i = +p.dataset.optionIndex;
      const active = $('.is-active, .gt-swatch--active', p);
      selected[i] = cur0 ? cur0.options[i] : (active ? active.dataset.value : ($('[data-value]', p) || {}).dataset?.value);
    });
    let firstRun = true;

    function match() {
      return variants.find((v) => v.options.every((o, i) => selected[i] === undefined || norm(o) === norm(selected[i])))
        || (firstRun && cur0) || undefined;
    }

    function update() {
      const v = match();
      if (priceNow && v) priceNow.textContent = money(v.price);
      if (v && v.compare_at > v.price) {
        priceBlock?.classList.add('is-sale');
        if (priceWas) { priceWas.textContent = money(v.compare_at); priceWas.style.display = ''; }
      } else {
        priceBlock?.classList.remove('is-sale');
        if (priceWas) priceWas.style.display = 'none';
      }
      if (select && v) select.value = v.id;
      { var galEl = document.querySelector('[data-gal]'); var colPick = pickers.find((p) => p.hasAttribute('data-swatches')); var colVal = colPick ? selected[+colPick.dataset.optionIndex] : null; if (galEl && galEl.applyColor && (colVal || (v && v.media_id))) { galEl.applyColor(colVal, v && v.media_id);  } }
      const ok = v && v.available;
      firstRun = false;
      if (addBtn) addBtn.disabled = !ok;
      if (addLabel) addLabel.textContent = !v ? T('unavailable') : (v.available ? T('add_to_cart') : T('sold_out'));
      // mark sold-out sizes for the current colour selection
      pickers.forEach((p) => {
        const idx = +p.dataset.optionIndex;
        if (p.hasAttribute('data-swatches')) return;
        $$('[data-variant]', p).forEach((btn) => {
          const trial = selected.slice(); trial[idx] = btn.dataset.value;
          const tv = variants.find((vv) => vv.options.every((o, i) => o === trial[i]));
          btn.classList.toggle('is-soldout', !(tv && tv.available));
        });
      });
    }

    root.addEventListener('click', (e) => {
      const swatch = e.target.closest('[data-swatch]');
      const size = e.target.closest('[data-variant]:not(.is-soldout)');
      if (swatch) {
        const p = swatch.closest('[data-option-index]'); const i = +p.dataset.optionIndex;
        selected[i] = swatch.dataset.value;
        $$('[data-swatch]', p).forEach((x) => x.classList.remove('gt-swatch--active'));
        swatch.classList.add('gt-swatch--active');
        const echo = $('[data-swatch-name]', p); if (echo) echo.textContent = swatch.dataset.name;
        update();
      } else if (size) {
        const p = size.closest('[data-option-index]'); const i = +p.dataset.optionIndex;
        selected[i] = size.dataset.value;
        $$('[data-variant]', p).forEach((x) => x.classList.remove('is-active'));
        size.classList.add('is-active');
        update();
      }
    });
    update();
  });

  /* ---------- Collection sort (reload with ?sort_by=) ---------- */
  $$('[data-sort]').forEach((sel) => sel.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    window.location.href = url.toString();
  }));

  /* ---------- PDP: image zoom lightbox ---------- */
  (function () {
    var lb;
    function ensure() {
      if (lb) return lb;
      var s = document.createElement('style');
      s.textContent = '.gt-pdp__mediagrid img{cursor:zoom-in}.gt-lightbox{position:fixed;inset:0;z-index:300;background:rgba(11,11,10,.93);display:flex;align-items:center;justify-content:center;cursor:zoom-out;opacity:0;visibility:hidden;transition:opacity .25s}.gt-lightbox.is-open{opacity:1;visibility:visible}.gt-lightbox img{max-width:92vw;max-height:92vh;object-fit:contain}.gt-lightbox__x{position:absolute;top:16px;right:20px;color:#F6F4EF;font-size:30px;line-height:1;background:none;border:0;cursor:pointer}';
      document.head.appendChild(s);
      lb = document.createElement('div');
      lb.className = 'gt-lightbox';
      lb.innerHTML = '<button class="gt-lightbox__x" aria-label="Schliessen">\u00d7</button><img alt="">';
      lb.addEventListener('click', close);
      document.body.appendChild(lb);
      return lb;
    }
    function open(src) { ensure(); lb.querySelector('img').src = src; lb.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { if (lb) { lb.classList.remove('is-open'); document.body.style.overflow = ''; } }
    document.addEventListener('click', function (e) {
      var img = e.target.closest('.gt-pdp__mediagrid img, [data-main-img]');
      if (img) { e.preventDefault(); open(img.currentSrc || img.src); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  })();

  /* ---------- Product cards: variant swatches + cart button ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-card-swatch]');
    if (sw) {
      e.preventDefault();
      var card = sw.closest('[data-card]'); if (!card) return;
      var img = card.querySelector('[data-card-imgwrap] img');
      if (img && sw.dataset.img) { var nimg = new Image(); nimg.onload = function () { img.removeAttribute('srcset'); img.src = sw.dataset.img; }; nimg.src = sw.dataset.img; var alt = card.querySelector('[data-card-alt]'); if (alt) alt.style.display = 'none'; }
      card.querySelectorAll('[data-card-swatch]').forEach(function (x) { x.classList.toggle('is-active', x === sw); });
      var vs = []; try { vs = JSON.parse(card.querySelector('[data-card-variants]').textContent); } catch (err) {}
      var qb = card.querySelector('.gt-qb');
      if (qb) {
        var si = +qb.dataset.sizeIndex, ci = +qb.dataset.colorIndex;
        qb.querySelectorAll('[data-qb-id]').forEach(function (inp) {
          var v = vs.find(function (x) { return x.a && x.o[si] === inp.dataset.size && (ci < 0 || x.o[ci] === sw.dataset.value); });
          inp.value = v ? v.id : '';
          var b = inp.parentNode.querySelector('button'); if (b) b.disabled = !v;
        });
      }
      var single = card.querySelector('[data-card-single]');
      if (single) { var v1 = vs.find(function (x) { return x.a && x.o.indexOf(sw.dataset.value) > -1; }); if (v1) single.value = v1.id; }
      return;
    }
    var cb = e.target.closest('[data-card-cart]');
    if (cb) { e.preventDefault(); var c = cb.closest('[data-card]'); if (c) c.classList.toggle('is-qb-open'); return; }
    document.querySelectorAll('[data-card].is-qb-open').forEach(function (c2) { if (!c2.contains(e.target)) c2.classList.remove('is-qb-open'); });
  });

  /* ---------- Featured collection slider ---------- */
  function fcState(sec){ var t = sec.querySelector('[data-fc-track]'); if (!t) return; var p = sec.querySelector('[data-fc-prev]'), n = sec.querySelector('[data-fc-next]'); if (p) p.disabled = t.scrollLeft <= 4; if (n) n.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4; }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fc-prev],[data-fc-next]'); if (!b) return;
    var sec = b.closest('section'); var t = sec && sec.querySelector('[data-fc-track]'); if (!t) return;
    var card = t.firstElementChild; var step = card ? card.getBoundingClientRect().width + 28 : t.clientWidth;
    t.scrollBy({ left: b.hasAttribute('data-fc-next') ? step : -step, behavior: 'smooth' });
  });
  $$('.gt-fc-track').forEach(function (t) { var sec = t.closest('section'); t.addEventListener('scroll', function () { fcState(sec); }, { passive: true }); fcState(sec); });

  /* ---------- smooth, slow scroll for in-page links (e.g. "Mehr lesen") ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]'); if (!a) return;
    var id = a.getAttribute('href').slice(1); if (!id) return;
    var el = document.getElementById(id); if (!el) return;
    e.preventDefault();
    var hdr = document.querySelector('.gt-header'); var off = (hdr ? hdr.offsetHeight : 0) + 24;
    var start = window.pageYOffset, end = el.getBoundingClientRect().top + start - off, d = end - start, dur = Math.min(1400, Math.max(700, Math.abs(d) * 0.6)), t0 = null;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollTo(0, end); return; }
    function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function step(ts) { if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / dur); window.scrollTo(0, start + d * ease(p)); if (p < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  });


  /* ---------- Live search overlay (Shopify predictive search) ---------- */
  (function () {
    var ov, inp, res, timer, ctrl, lastQ = '';
    function css() {
      var s = document.createElement('style');
      s.textContent = '.gt-ps{position:fixed;inset:0;z-index:400;display:flex;flex-direction:column;pointer-events:none}'+
      '.gt-ps__bg{position:absolute;inset:0;background:rgba(11,11,10,.38);opacity:0;transition:opacity .3s}'+
      '.gt-ps__box{position:relative;background:var(--color-bg);transform:translateY(-100%);transition:transform .38s cubic-bezier(.22,1,.36,1);max-height:88vh;display:flex;flex-direction:column;box-shadow:0 18px 50px rgba(11,11,10,.14)}'+
      '.gt-ps.is-open{pointer-events:auto}.gt-ps.is-open .gt-ps__bg{opacity:1}.gt-ps.is-open .gt-ps__box{transform:none}'+
      '.gt-ps__bar{max-width:var(--container);width:100%;margin:0 auto;padding:18px var(--gutter);display:flex;align-items:center;gap:14px;border-bottom:1px solid var(--color-line)}'+
      '.gt-ps__bar input{flex:1;min-width:0;border:0;background:transparent;font-family:var(--font-serif);font-weight:300;font-size:clamp(22px,3vw,34px);outline:none;color:var(--ink-900)}'+
      '.gt-ps__bar input::placeholder{color:var(--ink-300)}'+
      '.gt-ps__x{border:0;background:none;cursor:pointer;padding:8px;color:var(--ink-900);line-height:0}'+
      '.gt-ps__res{overflow-y:auto;scrollbar-width:none}.gt-ps__res::-webkit-scrollbar{display:none}'+
      '.gt-ps__in{max-width:var(--container);margin:0 auto;padding:22px var(--gutter) 30px;display:grid;grid-template-columns:220px minmax(0,1fr);gap:40px}'+
      '.gt-ps__h{font-size:11px;font-weight:500;letter-spacing:var(--tracking-label);text-transform:uppercase;color:var(--ink-500);margin:0 0 12px}'+
      '.gt-ps__links{display:flex;flex-direction:column;gap:9px;margin-bottom:22px}.gt-ps__links a{font-size:14px;color:var(--ink-800)}.gt-ps__links a:hover{text-decoration:underline;text-underline-offset:3px}'+
      '.gt-ps__links mark{background:none;color:var(--ink-900);font-weight:600}'+
      '.gt-ps__grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:18px}'+
      '.gt-ps__p{display:block;color:inherit}.gt-ps__p .im{aspect-ratio:3/4;background:var(--color-bg-alt);overflow:hidden;margin-bottom:10px}.gt-ps__p img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .5s}.gt-ps__p:hover img{transform:scale(1.04)}'+
      '.gt-ps__p .t{font-size:13px;line-height:1.35;color:var(--ink-900);display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}.gt-ps__p .pr{font-size:13px;margin-top:4px;display:flex;gap:8px}.gt-ps__p .pr s{color:var(--ink-400)}.gt-ps__p .pr .sale{color:#8A2B22}'+
      '.gt-ps__all{display:inline-flex;margin-top:22px;font-size:12px;letter-spacing:var(--tracking-label);text-transform:uppercase;border-bottom:1px solid var(--ink-900);padding-bottom:3px;color:var(--ink-900)}'+
      '.gt-ps__empty{font-size:14px;color:var(--ink-500);padding:10px 0}'+
      '.gt-ps__load{height:2px;background:linear-gradient(90deg,transparent,var(--ink-900),transparent);background-size:40% 100%;background-repeat:no-repeat;animation:gtps 1s linear infinite;opacity:0}.gt-ps.is-loading .gt-ps__load{opacity:1}@keyframes gtps{from{background-position:-40% 0}to{background-position:140% 0}}'+
      '@media(max-width:900px){.gt-ps__box{max-height:100vh;height:100%}.gt-ps__bar{padding:12px 14px}.gt-ps__bar input{font-size:20px}.gt-ps__in{grid-template-columns:1fr;gap:6px;padding:16px 14px 24px}.gt-ps__grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:12px}.gt-ps__links{flex-direction:row;flex-wrap:wrap;gap:8px}.gt-ps__links a{border:1px solid var(--color-line);padding:7px 12px;font-size:12px}}';
      document.head.appendChild(s);
    }
    function build() {
      css();
      ov = document.createElement('div'); ov.className = 'gt-ps'; ov.setAttribute('role','dialog'); ov.setAttribute('aria-label',T('search'));
      ov.innerHTML = '<div class="gt-ps__bg" data-ps-close></div><div class="gt-ps__box"><div class="gt-ps__bar"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg><input type="search" placeholder="'+T('search_ph')+'" autocomplete="off" aria-label="'+T('search_term')+'"><button class="gt-ps__x" data-ps-close aria-label="'+T('close')+'"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button></div><div class="gt-ps__load"></div><div class="gt-ps__res"></div></div>';
      document.body.appendChild(ov);
      inp = ov.querySelector('input'); res = ov.querySelector('.gt-ps__res');
      ov.addEventListener('click', function (e) { if (e.target.closest('[data-ps-close]')) close(); });
      inp.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(search, 180); });
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter' && inp.value.trim()) { window.location.href = GT_R+'search?q=' + encodeURIComponent(inp.value.trim()); } });
      idle();
    }
    function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]; }); }
    function hi(t, q) { t = esc(t); if (!q) return t; var i = t.toLowerCase().indexOf(q.toLowerCase()); return i < 0 ? t : t.slice(0, i) + '<mark>' + t.slice(i, i + q.length) + '</mark>' + t.slice(i + q.length); }
    function cents(v) { return Math.round(parseFloat(v || 0) * 100); }
    function idle() {
      var links = Array.prototype.slice.call(document.querySelectorAll('.gt-megamenu a, .gt-nav > a, .gt-nav__item > a')).filter(function (a) { return a.textContent.trim() && a.getAttribute('href') && a.getAttribute('href').indexOf(GT_R+'collections/') > -1; });
      var seen = {}, html = '';
      links.forEach(function (a) { var t = a.textContent.trim(); if (seen[t] || Object.keys(seen).length >= 8) return; seen[t] = 1; html += '<a href="' + a.getAttribute('href') + '">' + esc(t) + '</a>'; });
      res.innerHTML = '<div class="gt-ps__in"><div><p class="gt-ps__h">'+T('popular_cats')+'</p><div class="gt-ps__links">' + html + '</div></div><div><p class="gt-ps__h">'+T('tip')+'</p><p class="gt-ps__empty">'+T('search_tip')+'</p></div></div>';
    }
    function search() {
      var q = inp.value.trim(); if (q === lastQ) return; lastQ = q;
      if (q.length < 2) { idle(); return; }
      if (ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
      ov.classList.add('is-loading');
      fetch(GT_R+'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=8&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (d) {
          ov.classList.remove('is-loading');
          var R = (d && d.resources && d.resources.results) || {}, P = R.products || [], C = R.collections || [], Q = R.queries || [];
          var left = '';
          if (Q.length) left += '<p class="gt-ps__h">'+T('suggestions')+'</p><div class="gt-ps__links">' + Q.slice(0, 5).map(function (x) { return '<a href="' + x.url + '">' + hi(x.text, q) + '</a>'; }).join('') + '</div>';
          if (C.length) left += '<p class="gt-ps__h">'+T('categories')+'</p><div class="gt-ps__links">' + C.slice(0, 5).map(function (x) { return '<a href="' + x.url + '">' + hi(x.title, q) + '</a>'; }).join('') + '</div>';
          var right = P.length ? '<p class="gt-ps__h">'+T('products')+'</p><div class="gt-ps__grid">' + P.slice(0, 8).map(function (p) {
            var pr = cents(p.price), cmp = cents(p.compare_at_price_max);
            var img = p.image || (p.featured_image && p.featured_image.url) || '';
            if (img && img.indexOf('?') < 0) img += '?width=400';
            return '<a class="gt-ps__p" href="' + p.url + '"><div class="im">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div><div class="t">' + hi(p.title, q) + '</div><div class="pr">' + (cmp > pr ? '<s>' + money(cmp) + '</s><span class="sale">' + money(pr) + '</span>' : '<span>' + money(pr) + '</span>') + '</div></a>';
          }).join('') + '</div><a class="gt-ps__all" href="' + GT_R + 'search?q=' + encodeURIComponent(q) + '">' + T('all_results').replace('%q', esc(q)) + '</a>' : '<p class="gt-ps__empty">' + T('no_hits').replace('%q', esc(q)) + '</p>';
          res.innerHTML = '<div class="gt-ps__in"><div>' + (left || '') + '</div><div>' + right + '</div></div>';
        }).catch(function (e) { if (e && e.name === 'AbortError') return; ov.classList.remove('is-loading'); });
    }
    function open() {
      if (!ov) build();
      closeAll && closeAll();
      ov.classList.add('is-open'); document.body.style.overflow = 'hidden';
      setTimeout(function () { inp.focus(); }, 60);
    }
    function close() { if (!ov) return; ov.classList.remove('is-open'); document.body.style.overflow = ''; }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('a[href$="/search"], [data-open-search]');
      if (t && !t.closest('.gt-ps')) { e.preventDefault(); open(); }
    });
    document.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches('.gt-mnav__search input')) { e.target.blur(); open(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); if ((e.key === '/' ) && !/input|textarea/i.test((document.activeElement || {}).tagName)) { e.preventDefault(); open(); } });
  })();

  /* ---------- Cart drawer: robust checkout (works even if form submit is intercepted) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gt-checkout]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    b.setAttribute('aria-busy', 'true'); b.style.opacity = '.7';
    window.location.href = '/checkout';
  }, true);

  /* init drawer counts on load */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  /* ---------- PDP: sticky add-to-cart bar ---------- */
  (function () {
    var bar = $('[data-stickybar]'); if (!bar) return;
    var form = $('form[data-gt-add]');
    var actions = $('.gt-pdp__actions');
    var addBtn = $('[data-sticky-add]');
    if (addBtn && form) addBtn.addEventListener('click', function () {
      var sel = $('[data-variant-select]', form);
      addToCart(form);
    });
    var sp = $('[data-price]'); var target = $('[data-sticky-price]');
    if (sp && target) new MutationObserver(function () { target.textContent = sp.textContent; })
      .observe(sp, { childList: true, characterData: true, subtree: true });
    window.addEventListener('scroll', function () {
      if (!actions) return;
      var past = actions.getBoundingClientRect().bottom < 0;
      var nearFoot = (window.innerHeight + window.scrollY) > (document.body.scrollHeight - 200);
      bar.classList.toggle('is-visible', past && !nearFoot);
    }, { passive: true });
  })();

  /* ---------- Recently viewed (localStorage) ---------- */
  (function () {
    var KEY = 'gt_recently'; var cur = $('[data-current-product]');
    var sect = $('[data-recently]'); var grid = $('[data-recently-grid]');
    function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    if (cur) {
      try {
        var p = JSON.parse(cur.textContent); var list = read().filter(function (h) { return h !== p.handle; });
        list.unshift(p.handle); write_(list.slice(0, 8));
      } catch (e) {}
    }
    function write_(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
    if (sect && grid) {
      var handles = read().filter(function (h) { return !cur || h !== JSON.parse(cur.textContent).handle; }).slice(0, 4);
      if (handles.length) {
        Promise.all(handles.map(function (h) {
          return fetch(GT_R+'products/' + h + '?view=card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
        })).then(function (cards) {
          var html = cards.filter(Boolean).join('');
          if (html.trim()) { grid.innerHTML = html; sect.style.display = ''; }
        });
      }
    }
  })();
  (function(){
    var root=document.querySelector('[data-mnav]');if(!root)return;
    var stack=['root'];
    function show(id,back){
      root.querySelectorAll('[data-mnav-panel]').forEach(function(p){var k=p.getAttribute('data-mnav-panel');p.classList.remove('is-on','is-prev');if(k===id)p.classList.add('is-on');else if(stack.indexOf(k)>-1)p.classList.add('is-prev');});
      var on=root.querySelector('[data-mnav-panel="'+id+'"]');if(on)on.scrollTop=0;
    }
    root.addEventListener('click',function(e){
      var g=e.target.closest('[data-mnav-go]');if(g){stack.push(g.getAttribute('data-mnav-go'));show(stack[stack.length-1]);return;}
      var b=e.target.closest('[data-mnav-back]');if(b&&stack.length>1){stack.pop();show(stack[stack.length-1]);}
    });
    document.addEventListener('click',function(e){if(e.target.closest('[data-gt="open-nav"]')){stack=['root'];show('root');}});
    var nav=root.closest('.gt-mobile-nav');
    nav.addEventListener('click',function(e){if(e.target.closest('[data-gt="open-cart"]')){nav.classList.remove('is-open');}});
  })();
})();
